import { Layout } from 'antd'
import React, { FC, ReactElement, useEffect, useState } from 'react'
import { EventActiveArg } from '../../types'
import { Booking } from './Booking'
import { EventHubEventFragment, useEventHubEventsQuery } from './EventHub.generated-types'
import { SideBar } from './SideBar'
import { s } from './style'

const { Content, Sider } = Layout

export const EventHub: FC = (): ReactElement => {
  const [selectedEventListItem, setSelectedEventListItem] = useState<EventHubEventFragment>()

  const [{ fetching: activeLoading, error: activeError, data: activeData }, refetchActive] =
    useEventHubEventsQuery({
      variables: { active: EventActiveArg.Active, sort: { fromDateTimeAscending: false } },
      requestPolicy: 'cache-and-network',
    })

  const [{ fetching: inactiveLoading, error: inactiveError, data: inactiveData }, refetchInactive] =
    useEventHubEventsQuery({
      variables: { active: EventActiveArg.Inactive, sort: { fromDateTimeAscending: false } },
      requestPolicy: 'cache-and-network',
    })

  useEffect(() => {
    if (activeData?.getEventsByUser) {
      if (activeData?.getEventsByUser.length > 0) {
        setSelectedEventListItem(activeData.getEventsByUser[0])
      } else if (inactiveData?.getEventsByUser.length > 0) {
        setSelectedEventListItem(inactiveData.getEventsByUser[0])
      }
    }
  }, [activeData, inactiveData])

  const onCancelEventSuccess = async (): Promise<any> => {
    return await Promise.all([refetchActive(), refetchInactive()])
  }

  const loadingActiveEvents = activeLoading && !activeData
  const loadingInactiveEvents = inactiveLoading && !inactiveData

  const hasNoEvents =
    activeData?.getEventsByUser?.length < 1 && inactiveData?.getEventsByUser?.length < 1

  const eventsLoading =
    (activeLoading || inactiveLoading) && activeData != null && inactiveData != null

  return (
    <Layout>
      <div className='sideBarWrapper' style={s.sideWrapper}>
        <Sider width={309} style={{ marginLeft: 'auto' }}>
          <SideBar
            activeLoading={loadingActiveEvents}
            activeError={activeError}
            activeEvents={activeData?.getEventsByUser}
            inactiveLoading={loadingInactiveEvents}
            inactiveError={inactiveError}
            inactiveEvents={inactiveData?.getEventsByUser}
            setSelectedEventListItem={setSelectedEventListItem}
            selectedEventListItem={selectedEventListItem}
          />
        </Sider>
      </div>
      <Content style={s.mainContent}>
        <Booking
          selectedEventUUID={selectedEventListItem?.UUID}
          onCancelEventSuccess={onCancelEventSuccess}
          hasNoEvents={hasNoEvents}
          eventsLoading={eventsLoading}
        />
      </Content>
    </Layout>
  )
}
